<template>
  <div :class="[isHighlight ? 'intro' : 'text', textColor, listStyleClasses]">
    <slot></slot>
  </div>
</template>

<script>
import { computed } from "vue";
import { useCustomValidator } from "../../compostables/useValidators";

export default {
  props: {
    color: {
      type: String,
      required: false,
      default: null,
      validator(value) {
        return useCustomValidator(["navy", "white"], value);
      },
    },
    isHighlight: {
      type: Boolean,
      required: false,
      default: false,
    },
    listStyle: {
      type: String,
      required: false,
      default: null,
      validator(value) {
        return useCustomValidator(["arrow"], value);
      },
    },
  },

  setup(props) {
    const textColor = computed(() => ({
      "text--navy": props.color === "navy",
      "text--white": props.color === "white",
      // switch (props.color) {
      //   case "navy":
      //     return "child:text-navy";
      //     break;

      //   case "white":
      //     return "child:text-white";
      //     break;

      //   default:
      //     return "child:text-default";
      //     break;
      // }
    }));

    const listStyleClasses = computed(() => {
      return {
        "list-style list-style--arrows": props.listStyle === "arrow",
      };
    });

    return {
      listStyleClasses,
      textColor,
    };
  },
};
</script>

<style></style>
